import * as React from 'react'
import { Helmet } from 'react-helmet'
import { Box, Button, Stack, Typography } from '@mui/material'
import { ACCESS_DENIED_REASONS } from '../../stores/contextAccess'
import { useBootstrapStore } from '../../stores/useBootstrapStore'
import { accessDeniedOverlaySx } from './overlayLayout'

const COPY = {
    [ACCESS_DENIED_REASONS.REQUIRES_LOGIN]: {
        message:
            'This graph is private. Log in to view, or ask the owner for access.',
        showLogin: true,
        secondaryLabel: 'Home',
    },
    [ACCESS_DENIED_REASONS.FORBIDDEN]: {
        message: "You don't have access to this graph.",
        secondaryLabel: 'Go to your graphs',
    },
    [ACCESS_DENIED_REASONS.NOT_FOUND]: {
        message: "This graph doesn't exist.",
        secondaryLabel: 'Go home',
    },
    [ACCESS_DENIED_REASONS.UNAVAILABLE]: {
        message: "Couldn't load this graph right now. Try again in a moment.",
        showRetry: true,
        secondaryLabel: 'Go home',
    },
}

const APPS_HREF = '/apps'
const HOME_HREF = '/'

export default function AccessDeniedScreen({ reason }) {
    const copy = COPY[reason] ?? COPY[ACCESS_DENIED_REASONS.FORBIDDEN]
    const currentUrl =
        window.location.pathname + window.location.search + window.location.hash
    const loginHref = `/login?redirect=${encodeURIComponent(currentUrl)}`

    const onRetry = () => {
        const store = useBootstrapStore.getState()
        // bootstrap() short-circuits when bootState !== IDLE, so a retry has
        // to drop back to IDLE first. reset() also clears the prior error.
        store.reset()
        store.bootstrap()
    }

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
            </Helmet>
            <Box
                role="alert"
                className="access-denied-screen"
                sx={{ ...accessDeniedOverlaySx, p: 4 }}
            >
                <Stack spacing={3} alignItems="center" maxWidth={520}>
                    <Typography
                        variant="h5"
                        component="h1"
                        align="center"
                        color="text.primary"
                    >
                        {copy.message}
                    </Typography>
                    <Stack
                        direction="row"
                        spacing={2}
                        flexWrap="wrap"
                        justifyContent="center"
                    >
                        {copy.showLogin && (
                            <Button
                                variant="contained"
                                component="a"
                                href={loginHref}
                            >
                                Log in
                            </Button>
                        )}
                        {copy.showRetry && (
                            <Button variant="contained" onClick={onRetry}>
                                Try again
                            </Button>
                        )}
                        <Button
                            variant="outlined"
                            component="a"
                            href={HOME_HREF}
                        >
                            {copy.secondaryLabel}
                        </Button>
                        <Button
                            variant="outlined"
                            component="a"
                            href={'/signup'}
                        >
                            Sign Up
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </>
    )
}
